import type { TCreditFormCommonFields, TWorkplaceFormFields } from 'entities/creditForm';

export const getWorkplaceStepLabel = (
  formFields: TWorkplaceFormFields,
  formFieldsLabels: Partial<Record<keyof TCreditFormCommonFields, string>>,
  stepFields: Array<keyof TWorkplaceFormFields>,
) =>
  stepFields.map((key) => {
    switch (key) {
      case 'areaOfEmployment':
      case 'jobTitle':
      case 'employmentType': {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]?.label),
        };
      }
      default: {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]),
        };
      }
    }
  });
